import { create } from "zustand";
import { CreditProposalState, CreditProposalStateValues } from "./types";

const initialValues: CreditProposalStateValues = {
  proposalData: undefined,
  isReanalysis: undefined,
  postSaveAction: undefined
};

export const useCreditProposalStore = create<CreditProposalState>()(
  (set, get) => ({
    ...initialValues,
    setProposalData: (data) => {
      set({ proposalData: data });
    },
    updateProposalData: (data) => {
      const current = get();
      if (current.proposalData) {
        const updated = {
          ...current.proposalData,
          ...data
        };
        set({
          proposalData: updated
        });
      } else {
        set({ proposalData: data });
      }
    },
    setReanalysis: (isReanalysis) => {
      set({ isReanalysis });
    },
    setPostSaveAction: (postSaveAction) => {
      set({ postSaveAction });
    },
    resetCreditProposalStore: () => {
      set(initialValues);
    }
  })
);
